import { join } from 'node:path';
import { writeJson } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { DEPENDENCIES_METADATA_FILENAME } from '@wix/cli-core-definitions';

export async function saveDependenciesMetadata(
  projectFolder: string,
  metadataContent: unknown
) {
  const metadataPath = join(projectFolder, DEPENDENCIES_METADATA_FILENAME);
  try {
    await writeJson(metadataPath, metadataContent);
  } catch (e) {
    throw new CliError({
      code: CliErrorCode.FailedToWriteDependenciesMetadata(),
      cause: e,
    });
  }
}
